import { ChangeDetectorRef, Injectable } from '@angular/core';
import { OverflowFader } from '@prlw/libs/overflow-fader/overflow-fader.class';

@Injectable({ providedIn: 'root' })
export class OverflowFaderFactory {
  public create(changeDetectorRef: ChangeDetectorRef): OverflowFader {
    return new OverflowFader(changeDetectorRef);
  }
}
